import axios from "axios";
const apiURL = process.env.REACT_APP_API_URL;

const BearerToken = () =>
  localStorage.getItem("jwt")
    ? JSON.parse(localStorage.getItem("jwt")).token
    : false;

const Headers = () => {
  return {
    headers: {
      token: `Bearer ${BearerToken()}`,
    },
  };
};

export const getUserById = async (uId, loggedInUserId) => {
  try {
    let res = await axios.post(`${apiURL}/api/user/single-user`, { uId, loggedInUserId }, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const updatePersonalInformationFetch = async (userData) => {
  try {
    let res = await axios.post(`${apiURL}/api/user/edit-user`, userData, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getOrderByUser = async (uId, loggedInUserId) => {
  try {
    let res = await axios.post(`${apiURL}/api/order/order-by-user`, { uId, loggedInUserId }, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const updatePassword = async (formData) => {
  try {
    let res = await axios.post(`${apiURL}/api/user/change-password`, formData, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
